module.exports = __webpack_public_path__ + "static/media/cununie-icon.4371f4d8.svg";